import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import GeneralExcess from '../../coverNotePVComponent/generalExcess/GeneralExcess';
import ThirdPartyPropertyDamageExcess from '../../coverNotePVComponent/thirdPartyPropertyDamageExcess/ThirdPartyPropertyDamageExcess';
import TheftLossExcess from '../../coverNotePVComponent/theftLossExcess/TheftLossExcess';
import UnnamedDriverExcess from '../../coverNotePVComponent/unnamedDriverExcess/UnnamedDriverExcess';
import ParkingDamageExcess from '../../coverNotePVComponent/parkingDamageExcess/ParkingDamageExcess';
import YoungDriverExcess from '../../coverNotePVComponent/youngDriverExcess/YoungDriverExcess';
import InexperienceDriverExcess from '../../coverNotePVComponent/inexperienceDriverExcess/InexperienceDriverExcess';
import Remark from '../../coverNotePVComponent/remark/Remark';

class ExcessDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Excess Detail</h3>
          <FormGroup controlId="">
            <Col componentClass={ControlLabel} sm={6}>
              Section(I) Insurance-Own Damage
            </Col>
            <Col componentClass={ControlLabel} sm={6}>
              Section(II) Insurance-Third Party Property Damage
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <GeneralExcess
                generalExcess={this.props.excessDetail.section1InsuranceOwnDamage.generalExcess}
                handleChangeGeneralExcess={this.props.handleChangeExcessDetailSection1}
               />
            </Col>
            <Col sm={6}>
              <ThirdPartyPropertyDamageExcess
                thirdPartyPropertyDamageExcess={this.props.excessDetail.section2InsuranceThirdPartyPropertyDamage.thirdPartyPropertyDamageExcess}
                handleChangeThirdPartyPropertyDamageExcess={this.props.handleChangeExcessDetailSection2}
               />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <TheftLossExcess
                theftLossExcess={this.props.excessDetail.section1InsuranceOwnDamage.theftLossExcess}
                handleChangeTheftLossExcess={this.props.handleChangeExcessDetailSection1}
              />
            </Col>
            <Col sm={6}>
              <UnnamedDriverExcess
                unnamedDriverExcess={this.props.excessDetail.section2InsuranceThirdPartyPropertyDamage.unnamedDriverExcess}
                handleChangeUnnamedDriverExcess={this.props.handleChangeExcessDetailSection2}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <ParkingDamageExcess
                parkingDamageExcess={this.props.excessDetail.section1InsuranceOwnDamage.parkingDamageExcess}
                handleChangeParkingDamageExcess={this.props.handleChangeExcessDetailSection1}
              />
            </Col>
            <Col sm={6}>
              <YoungDriverExcess
                youngDriverExcess={this.props.excessDetail.section2InsuranceThirdPartyPropertyDamage.youngDriverExcess}
                handleChangeYoungDriverExcess={this.props.handleChangeExcessDetailSection2}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <UnnamedDriverExcess
                unnamedDriverExcess={this.props.excessDetail.section1InsuranceOwnDamage.unnamedDriverExcess}
                handleChangeUnnamedDriverExcess={this.props.handleChangeExcessDetailSection1}
              />
            </Col>
            <Col sm={6}>
              <InexperienceDriverExcess
                inexperienceDriverExcess={this.props.excessDetail.section2InsuranceThirdPartyPropertyDamage.inexperienceDriverExcess}
                handleChangeInexperienceDriverExcess={this.props.handleChangeExcessDetailSection2}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <YoungDriverExcess
                youngDriverExcess={this.props.excessDetail.section1InsuranceOwnDamage.youngDriverExcess}
                handleChangeYoungDriverExcess={this.props.handleChangeExcessDetailSection1}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <InexperienceDriverExcess
                inexperienceDriverExcess={this.props.excessDetail.section1InsuranceOwnDamage.inexperienceDriverExcess}
                handleChangeInexperienceDriverExcess={this.props.handleChangeExcessDetailSection1}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <Remark
                remark={this.props.excessDetail.remark}
                handleChangeRemark={this.props.handleChangeExcessDetail}
              />
            </Col>
            <Col sm={6} />s
          </FormGroup>
      </div>
    )
  }
}

ExcessDetail.propTypes = {
  excessDetail: PropTypes.object,
  handleChangeExcessDetailSection1: PropTypes.func,
  handleChangeExcessDetailSection2: PropTypes.func,
  handleChangeExcessDetail: PropTypes.func,
};

export default ExcessDetail;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/excessDetail/ExcessDetail.js